"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var panel_1 = require("../../../../components/pricing/layout/panel/panel");

var days_supply_field_1 = require("../../fields/days-supply-field/days-supply-field");

var drug_search_field_connected_1 = require("../../fields/drug-search-field/drug-search-field.connected");

var quantity_field_1 = require("../../fields/quantity-field/quantity-field");

var panelViewStyle = {
  alignItems: 'flex-start'
};
var drugSearchFieldStyle = {
  minWidth: '34rem',
  paddingRight: '1rem',
  width: '100%'
};
var numericInputFieldStyle = {
  width: '10em'
};
var daysSupplyFieldStyle = numericInputFieldStyle;
var quantityFieldStyle = numericInputFieldStyle;

var PriceLookupInputPanel = function (_super) {
  __extends(PriceLookupInputPanel, _super);

  function PriceLookupInputPanel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      daysSupply: NaN,
      quantity: NaN
    };
    _this.drugSearchFieldRef = react_1.default.createRef();
    _this.daysSupplyFieldRef = react_1.default.createRef();
    _this.quantityFieldRef = react_1.default.createRef();

    _this.clear = function () {
      var drugSearchFieldRef = _this.drugSearchFieldRef.current;

      if (drugSearchFieldRef) {
        drugSearchFieldRef.clear();
      }

      var daysSupplyFieldRef = _this.daysSupplyFieldRef.current;

      if (daysSupplyFieldRef) {
        daysSupplyFieldRef.clear();
      }

      var quantityFieldRef = _this.quantityFieldRef.current;

      if (quantityFieldRef) {
        quantityFieldRef.clear();
      }

      _this.setState({
        daysSupply: NaN,
        quantity: NaN,
        selectedDrugNdc: undefined
      });
    };

    _this.validate = function () {
      var changeInfo = {
        drugNdc: _this.state.selectedDrugNdc
      };
      var drugSearchFieldRef = _this.drugSearchFieldRef.current;

      if (drugSearchFieldRef) {
        drugSearchFieldRef.validate();
      }

      var daysSupplyFieldRef = _this.daysSupplyFieldRef.current;

      if (daysSupplyFieldRef) {
        changeInfo.daysSupply = daysSupplyFieldRef.validate();
      }

      var quantityFieldRef = _this.quantityFieldRef.current;

      if (quantityFieldRef) {
        changeInfo.quantity = quantityFieldRef.validate();
      }

      return changeInfo;
    };

    _this.focus = function () {
      var drugSearchFieldRef = _this.drugSearchFieldRef.current;

      if (drugSearchFieldRef) {
        drugSearchFieldRef.focus();
      }
    };

    _this.onSelectDrug = function (ndc) {
      _this.setState({
        selectedDrugNdc: ndc
      }, _this.sendOnChange);
    };

    _this.onSelectDaysSupply = function (daysSupply) {
      _this.setState({
        daysSupply: daysSupply
      }, _this.sendOnChange);
    };

    _this.onSelectQuantity = function (quantity) {
      _this.setState({
        quantity: quantity
      }, _this.sendOnChange);
    };

    _this.sendOnChange = function () {
      if (_this.props.onChange) {
        var changeInfo = {
          daysSupply: _this.state.daysSupply,
          drugNdc: _this.state.selectedDrugNdc,
          quantity: _this.state.quantity
        };

        _this.props.onChange(changeInfo);
      }
    };

    return _this;
  }

  PriceLookupInputPanel.prototype.render = function () {
    return react_1.default.createElement(panel_1.Panel, {
      viewStyle: panelViewStyle
    }, react_1.default.createElement(drug_search_field_connected_1.DrugSearchFieldConnected, {
      ref: this.drugSearchFieldRef,
      autoFocus: true,
      viewStyle: drugSearchFieldStyle,
      onSelect: this.onSelectDrug,
      onHelpDialogShow: this.props.onDrugSearchHelpDialogShow,
      isDisabled: this.props.isDisabled
    }), react_1.default.createElement(quantity_field_1.QuantityField, {
      ref: this.quantityFieldRef,
      viewStyle: quantityFieldStyle,
      onSelect: this.onSelectQuantity,
      isDisabled: this.props.isDisabled
    }), react_1.default.createElement(days_supply_field_1.DaysSupplyField, {
      ref: this.daysSupplyFieldRef,
      viewStyle: daysSupplyFieldStyle,
      onSelect: this.onSelectDaysSupply,
      isDisabled: this.props.isDisabled
    }));
  };

  return PriceLookupInputPanel;
}(react_1.default.Component);

exports.PriceLookupInputPanel = PriceLookupInputPanel;